import React from "react";

const SvgArrowRight = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="25"
      height="25"
      transform="matrix(-1 0 0 -1 25 25)"
      fill="#C299F5"
      fillOpacity="0.01"
    />
    <circle
      cx="12.5"
      cy="12.5"
      r="12.5"
      transform="rotate(-180 12.5 12.5)"
      fill="#B496FC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.60382 17.7399C9.29873 17.4348 9.29873 16.9402 9.60382 16.6351L13.7389 12.5L9.60382 8.36493C9.29873 8.05983 9.29873 7.56517 9.60382 7.26007C9.90892 6.95498 10.4036 6.95498 10.7087 7.26007L15.3962 11.9476C15.7013 12.2527 15.7013 12.7473 15.3962 13.0524L10.7087 17.7399C10.4036 18.045 9.90892 18.045 9.60382 17.7399Z"
      fill="white"
    />
  </svg>
);

export default SvgArrowRight;
